export default __webpack_public_path__ + "static/media/man.e1684d0f.svg";